import { render } from "./fieldClassification.vue?vue&type=template&id=7c710cb4&scoped=true"
import script from "./fieldClassification.vue?vue&type=script&lang=js"
export * from "./fieldClassification.vue?vue&type=script&lang=js"

import "./fieldClassification.vue?vue&type=style&index=0&id=7c710cb4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c710cb4"]])

export default __exports__